/* 注意: 只有在全局使用的过滤器才可以放到该文件中 */

/**
 * 格式化时间, 该方法只使用与UTC格式的时间
 * 格式之前: 2022-01-24T14:09:38.616148+08:00
 * 格式之后: 2022-01-24 14:09:38
 */
export const utcTimeFormatterFilter = (value) => {
  if (!value) return ''
  const time = value.replace('T', ' ').substring(0, 19)
  return time
}

/**
 * 根据vlaue, 展示data中对应的label
 * @param {*} val
 * @param {*} data
 * @param {*} type
 * @param {*} valueName
 * @param {*} labelName
 * @returns
 */
export const valueChangeIntoLabel = (val, data, type, valueName, labelName) => {
  if (!val) return ''
  const label = labelName || 'label'
  const value = valueName || 'value'
  let showData
  if (type === 'arr') {
    showData = data.find(item => item[value] === val)
  } else {
    showData = data[val]
  }
  return showData ? `${showData[label]} (${val})` : `未知(${val})`
}
